enum AutoContractGeneration {
  IN_REVISION_OR_ON_APPROVAL = 'IN_REVISION_OR_ON_APPROVAL',
  ON_APPROVAL = 'ON_APPROVAL',
  ON_APPROVED = 'ON_APPROVED',
}

export default AutoContractGeneration;
